// Libs
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { SWRResponse } from 'swr';
// App
import { EDENRED_ACOUNT_URL, REVALIDATE_ONLY_ON_MOUNT_SWR_OPTIONS } from './edenred-account.constants';
import { UserBalance } from './edenred-account.interfaces';
import { API_COMMON_BASE_URL } from '../../utils/api.constants';
import { useSWRAxiosGetRequest } from '../../utils/swr-axios-request.hooks';

/**
 * Acccount api hook
 */
export const useGetEdenredAccountBalance = (shouldFetch = false): SWRResponse<UserBalance, AxiosError> => {
  const urlOptional = shouldFetch ? `${API_COMMON_BASE_URL}/${EDENRED_ACOUNT_URL}/balance` : null;

  const response: SWRResponse<UserBalance, AxiosError> = useSWRAxiosGetRequest(
    urlOptional,
    REVALIDATE_ONLY_ON_MOUNT_SWR_OPTIONS
  );

  return response;
};

/**
 * Handles edenred account post login callback api
 */
export const handleEdenredPostLoginCallback = (
  code: string,
  redirectUri: string,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<void>> => {
  const url = `${API_COMMON_BASE_URL}/${EDENRED_ACOUNT_URL}/post-login?code=${code}&redirectUri=${redirectUri}`;

  return axios.post(url, null, config);
};

/**
 * Handles edenred account post logout callback api
 */
export const handleEdenredPostLogoutCallback = (config?: AxiosRequestConfig): Promise<AxiosResponse<void>> => {
  const url = `${API_COMMON_BASE_URL}/${EDENRED_ACOUNT_URL}/post-logout`;

  return axios.post(url, null, config);
};

/**
 * Handles edenred account post logout callback api
 */
export const deleteEdenredAccount = (config?: AxiosRequestConfig): Promise<AxiosResponse<void>> => {
  const url = `${API_COMMON_BASE_URL}/${EDENRED_ACOUNT_URL}`;

  return axios.delete(url, config);
};
